
export const assetViews = self => ({
  get viewableUrl() {
    return self.originUrl
  },
  get src() {
    if (!self.originUrl) return self.localUrl
    else return self.originUrl
  },
})